<template>
  <material-card
    style="margin-top:30px"
    scrollable
    :title="$t('components.plancreationwizard.activity_status')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="rule_folder"
  >
    <v-dialog scrollable v-model="dialogs.edit" persistent max-width="1000">
      <material-card
        :title="$t(activityStatusFormTitle)"
        :icon="activityStatusFormIcon"
        :color="formColor"
      >
        <v-card-text v-if="item">
          <v-form ref="form" v-model="valid">
            <v-container fluid fill-height>
              <v-row wrap>
                <v-col cols="12" md="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-container pa-0>
                        <v-row no-gutters>
                          <v-col cols="auto">
                            <trans-textbox
                              v-model="item.ActivityStatus"
                              :label="$t('globals.name')"
                              :rules="[$rules.required]"
                              class="required"
                              field="Name"
                            ></trans-textbox>
                          </v-col>
                          <v-col
                            style="margin-top:20px;margin-left:3px"
                            cols="auto"
                          >
                            <v-icon v-bind="attrs" v-on="on">help</v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                    <span>
                      {{
                        $t(
                          "components.plancreationwizard.activity_status_name_tooltip"
                        )
                      }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" md="6">
                  <no-autocomplete-textfield
                    style=""
                    :value="item.ActivityStatus.Code"
                    @change="item.ActivityStatus.Code = $event"
                    :label="$t('headers.employer_files.code')"
                    :rules="[$rules.requiredNum]"
                    class="required"
                    type="number"
                  ></no-autocomplete-textfield>
                </v-col>
                <v-col cols="12">
                  <trans-textarea
                    v-model="item.ActivityStatus"
                    :label="$t('globals.description')"
                    :rules="[$rules.required]"
                    class="required"
                    field="Description"
                  ></trans-textarea>
                </v-col>
                <v-col cols="12" md="3">
                  <trans-multi-select2
                    v-model="item.CoverageIdentities"
                    :items="coverage"
                    :label="$t('headers.activitystatus.maintained_benefits')"
                    field="Name"
                    itemValue="Identifier"
                  ></trans-multi-select2>
                </v-col>
                <v-col cols="12" md="3" v-if="item.CoverageIdentities">
                  <trans-multi-select2
                    v-model="item.WaivedCoverageIdentities"
                    :items="item.CoverageIdentities"
                    :label="$t('headers.activitystatus.waived_benefits')"
                    field="Name"
                    itemValue="Identifier"
                  ></trans-multi-select2>
                </v-col>
              </v-row>
              <v-row wrap>
                <v-col cols="12" md="3">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-container pa-0>
                        <v-row no-gutters>
                          <v-col cols="auto">
                            <v-checkbox
                              v-model="item.HasEndOfStatusClause"
                              :label="
                                $t(
                                  'headers.activitystatus.end_of_status_clause'
                                )
                              "
                            ></v-checkbox>
                          </v-col>
                          <v-col
                            style="margin-top:20px;margin-left:3px"
                            cols="auto"
                          >
                            <v-icon v-bind="attrs" v-on="on">help</v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                    <span>
                      {{
                        $t(
                          "components.plancreationwizard.activity_status_end_of_status_clause_tooltip"
                        )
                      }}
                    </span>
                  </v-tooltip>
                </v-col>
                <template v-if="item.HasEndOfStatusClause">
                  <v-col cols="12" md="3">
                    <!-- <auto-select
                      :value.sync="item.DurationUnit"
                      :items="options.Enums.TermTimeUnit"
                      :label="$t('headers.activitystatus.duration_unit')"
                      :slots="true"
                      :rules="[$rules.required]"
                      class="required"
                      :filter="filterFunc"
                    >
                      <template v-slot:selection="data">
                        {{ $t("enums." + data.item) }}
                      </template>
                      <template v-slot:item="data">
                        <v-list-item-content
                          v-text="$t('enums.' + data.item)"
                        ></v-list-item-content>
                      </template>
                    </auto-select> -->
                    <trans-enum
                      :value.sync="item.DurationUnit"
                      :items="options.Enums.TermTimeUnit"
                      :label="$t('headers.activitystatus.duration_unit')"
                      :rules="[$rules.required]"
                      class="required"
                    ></trans-enum>
                  </v-col>
                  <v-col cols="12" md="3">
                    <no-autocomplete-textfield
                      style=""
                      :value="item.Duration"
                      @change="item.Duration = $event"
                      :label="$t('headers.activitystatus.duration')"
                      :rules="[$rules.requiredNum]"
                      class="required"
                      type="number"
                    ></no-autocomplete-textfield>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-container pa-0>
                          <v-row no-gutters>
                            <v-col cols="auto">
                              <!-- <auto-select
                                clearable
                                :value.sync="item.EndOfStatusEvent"
                                :items="options.Enums.EndOfStatusEvent"
                                :label="
                                  $t(
                                    'headers.activitystatus.end_of_status_event'
                                  )
                                "
                                :slots="true"
                                :filter="filterFunc"
                              >
                                <template v-slot:selection="data">
                                  {{ $t("enums." + data.item) }}
                                </template>
                                <template v-slot:item="data">
                                  <v-list-item-content
                                    v-text="$t('enums.' + data.item)"
                                  ></v-list-item-content>
                                </template>
                              </auto-select> -->
                              <trans-enum
                                clearable
                                :value.sync="item.EndOfStatusEvent"
                                :items="options.Enums.EndOfStatusEvent"
                                :label="
                                  $t(
                                    'headers.activitystatus.end_of_status_event'
                                  )
                                "
                              ></trans-enum>
                            </v-col>
                            <v-col
                              style="margin-top:20px;margin-left:3px"
                              cols="auto"
                            >
                              <v-icon v-bind="attrs" v-on="on">help</v-icon>
                            </v-col>
                          </v-row>
                        </v-container>
                      </template>
                      <span>
                        {{
                          $t(
                            "components.plancreationwizard.activity_status_end_of_status_event_tooltip"
                          )
                        }}
                      </span>
                    </v-tooltip>
                  </v-col>
                </template>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="closeActivityStatus">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            @click="saveActivityStatusItem"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog v-model="dialogs.delete" scrollable persistent max-width="400">
      <material-card
        :title="$t('components.plancreationwizard.remove_activity_status')"
        :color="$vuetify.theme.themes.light.error"
        icon="remove"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogs.deleteActivityStatus = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="removeActivityStatusItem">
            {{ $t("globals.remove") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <pbas-data-table
      ref="table"
      :dataProvider="provider"
      :rowActions="rowActions"
      :floatActions="floatActions"
      fileNamePrefix="activityStatus"
      identifier="table"
      @error="error = $event"
    ></pbas-data-table>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import { mapGetters } from "vuex";
import { InMemoryProvider } from "pbas-vue-components";
import ActivityStatusHeaders from "@/headers/ActivityStatus";
import ErrorHandler from "@/components/ErrorHandler";
import TransTextbox from "@/components/TransTextbox";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import TransTextarea from "@/components/TransTextarea";
import TransMultiSelect2 from "@/components/TransMultiSelect2";
import AutoSelect from "@/components/AutoSelect";
import TransEnum from "@/components/TransEnum.vue";

export default {
  components: {
    ErrorHandler,
    TransTextbox,
    NoAutocompleteTextfield,
    TransTextarea,
    TransMultiSelect2,
    AutoSelect,
    TransEnum
  },
  props: [
    "activityStatusRules",
    "planIdentityId",
    "coverage",
    "effectiveDate",
    "disabled",
  ],
  data() {
    return {
      error: null,
      valid: false,
      dialogs: {
        edit: false,
        delete: false,
      },
      item: null,
      isNew: false,
      floatActions: [
        {
          name: "addActivityStatus",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.item = {
              ActivityStatus:{},
              Identifier: Math.random().toString(),
            };
            this.isNew = true;
            this.dialogs.edit = true;
          },
          visible: () => !this.disabled,
        },
      ],
      rowActions: [
        {
          name: "editActivityStatus",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.item = JSON.parse(JSON.stringify(item));
            this.isNew = false;
            this.dialogs.edit = true;
          },
          visible: () => !this.disabled,
        },
        {
          name: "removeActivityStatus",
          icon: "delete",
          title: "globals.remove",
          handler: (item) => {
            this.item = JSON.parse(JSON.stringify(item));
            this.dialogs.delete = true;
          },
          visible: () => !this.disabled,
        },
      ],
      provider: undefined,
      headers: ActivityStatusHeaders,
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("plansMembers", ["options"]),
    activityStatusFormTitle() {
      return this.isNew
        ? "components.plancreationwizard.create_new_activity_status"
        : "components.plancreationwizard.edit_activity_status";
    },
    activityStatusFormIcon() {
      return this.isNew ? "add" : "edit";
    },
    formColor() {
      return this.isNew ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
  },
  watch: {
    activityStatusRules: {
      handler(v) {
        if (this.provider !== null && this.provider !== undefined) {
          this.provider.items = v;
          this.$refs.table.getDataAsync();
        } else {
          this.provider = new InMemoryProvider(v, this.headers);
        }
      },
    },
    "item.CoverageIdentities": {
      handler(v) {
        if (v === null || v === undefined || v.length === 0) {
          if (this.item !== null && this.item !== undefined) {
            this.item.WaivedCoverageIdentities = [];
          }
        }
      },
    },
    "item.HasEndOfStatusClause": {
      handler(v) {
        if (!v) {
          if (this.item !== null && this.item !== undefined) {
            delete this.item.DurationUnit;
            delete this.item.Duration;
            delete this.item.EndOfStatusEvent;
          }
        }
      },
    },
  },
  mounted() {
    if (
      this.activityStatusRules !== null &&
      this.activityStatusRules !== undefined
    ) {
      this.provider = new InMemoryProvider(
        this.activityStatusRules,
        this.headers
      );
    }
  },
  methods: {
    saveActivityStatusItem() {
      let item = JSON.parse(JSON.stringify(this.item));
      item.ActivityStatus.EffectiveDate = this.effectiveDate;
      item.ActivityStatus.PlanIdentityId = this.planIdentityId;
      item.ActivityStatus.Description = item.ActivityStatus.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Description;
      if (!this.item.HasEndOfStatusClause) {
        delete item.DurationUnit;
        delete item.Duration;
        delete item.EndOfStatusEvent;
      }
      if (this.isNew) {
        this.addActivityStatusItem(item);
      } else {
        this.updateActivityStatusItem(item);
      }
    },
    updateActivityStatusItem(item) {
      let activityStatusItem;
      activityStatusItem = this.provider.items.filter(
        (o) => o.Identifier === item.Identifier
      )[0];

      this.provider.items[
        this.provider.items.indexOf(activityStatusItem)
      ] = item;

      this.closeActivityStatus();
      this.$refs.table.getDataAsync();
      this.$emit("update-activity-status", this.provider.items);
    },
    addActivityStatusItem(item) {
      item.ActivityStatus.Name = this.item.ActivityStatus.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Name;
      this.provider.items.push(item);
      this.closeActivityStatus();
      this.$refs.table.getDataAsync();
      this.$emit("update-activity-status", this.provider.items);
    },
    removeActivityStatusItem() {
      let item = JSON.parse(JSON.stringify(this.item));
      let activityStatusItem;
      activityStatusItem = this.provider.items.filter(
        (o) => o.Identifier === item.Identifier
      )[0];

      this.provider.items.splice(
        this.provider.items.indexOf(activityStatusItem),
        1
      );
      this.closeActivityStatus();
      this.$refs.table.getDataAsync();
      this.$emit("update-activity-status", this.provider.items);
    },
    closeActivityStatus() {
      this.dialogs.edit = false;
      this.dialogs.delete = false;
      this.item = null;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
  },
};
</script>

<style></style>
